<template>
  <div class="card" v-permission="'change_customer'">
    <div class="card-header d-flex justify-content-between">
      <b-form-group class="mb-0">
        <b-form-checkbox v-model="redFlagged" size="lg" switch @change="onRedFlagChange">
          <h5 class="d-inline-block mb-0">
            {{ $t('Red Flag') }}
          </h5>
        </b-form-checkbox>
      </b-form-group>
      <b-button v-if="red_flagged" class="float-right p-0" variant="link" v-permission="'change_customer'"
                @click="onRedFlagEditClick">
        <font-awesome-icon :icon="'pen'" style="font-size: .9em"/>
        {{ $t('Edit') }}
      </b-button>
    </div>
    <div class="card-body">
      <div v-if="red_flag_comment">
         <span class="title hover-cursor">
          {{ red_flag_comment | striptags | truncate }}
        </span>
      </div>
      <no-data-available v-else :height="5"/>
    </div>
    <red-flag-modal/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import NoDataAvailable from "../../../../core/components/common/NoDataAvailable";
  import RedFlagModal from "./modals/RedFlagModal";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');
  export default {
    name: "RedFlag",
    components: {RedFlagModal, NoDataAvailable},
    data() {
      return {
        redFlagged: false,
      }
    },
    computed: {
      ...mapState({
        red_flagged: state => state.termsData.red_flagged,
        red_flag_comment: state => state.termsData.red_flag_comment,
      })
    },
    watch: {
      ['red_flagged']() {
        this.redFlagged = this.red_flagged;
      },
    },
    methods: {
      ...mapActions(['saveTermsPartialData', 'toggleRedFlagModal']),
      async onRedFlagChange(checked) {
        let success = true
        let params = {
          red_flagged: checked
        }

        if (!checked) {
          success = await this.$confirm(this.$t('Are you sure you want to delete the note and remove red flag?'))
          if (success) {
            params.red_flag_comment = ''
          }
        }

        if (success) {
          await this.saveRedFlag(checked, params)
        } else {
          this.redFlagged = true
        }
      },
      async saveRedFlag(checked, params) {
        let response = await this.saveTermsPartialData({...params});
        if (response.success) {
          if (checked) {
            await this.toggleRedFlagModal(true)
          }
          this.$toast('success', this.$t('Red Flag was successfully saved'));
          return true;
        } else {
          this.$toast('danger', this.$t('Unable to save red flag'));
          return false;
        }
      },
      onRedFlagEditClick() {
        this.toggleRedFlagModal(true)
      },
      async beforeRouteLeave() {
        if (this.redFlagged && !this.red_flag_comment) {
          const success = await this.$confirm(this.$t('Are you sure you want to leave the note empty? Red Flag will be remove'))
          if (success) {
            let params = {
              red_flagged: false,
              red_flag_comment: ''
            }
            return await this.saveRedFlag(false, params);
          }
          this.redFlagged = true
          return false
        }
        return true
      },
    },
    mounted() {
      this.redFlagged = this.red_flagged;
    },
  }
</script>

<style scoped>

</style>
